import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiClient } from "@/context/AuthContext";
import NewAssessmentModal from "@/components/NewAssessmentModal";

export default function NewAssessmentLauncher({ onClose }) {
  const navigate = useNavigate();
  const [data, setData] = useState(null);

  useEffect(() => { (async () => {
    const [c, p, a] = await Promise.allSettled([
      apiClient.get("/catalog/building-classes"), apiClient.get("/projects"), apiClient.get("/catalog/local-authorities"),
    ]);
    const val = (r) => (r.status === "fulfilled" ? r.value.data : []) || [];
    setData({ classes: val(c), projects: val(p), authorities: val(a) });
  })(); }, []);

  if (!data) return null;
  return <NewAssessmentModal {...data} onClose={onClose} onCreated={(ass) => { onClose(); navigate(`/assessments/${ass.id}`); }}/>;
}
